module.exports = __webpack_public_path__ + "img/app-huawei.6c54f55f.png";